/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { SlsRtnFServ02Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const slsRtnFServ02ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const slsRtnFServ02ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const slsRtnFServ02ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const slsRtnFServ02ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const slsRtnFServ02ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const slsRtnFServ02FetchSlsRtnFServ02Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const slsRtnFServ02FetchSlsRtnFServ02Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const slsRtnFServ02AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const slsRtnFServ02RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const slsRtnFServ02SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const slsRtnFServ02ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_SHOW_SYNC_SETTING_LOADING]: slsRtnFServ02ShowSyncSettingLoading,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_SHOW_SYNC_SETTING_SUCCESS]: slsRtnFServ02ShowSyncSettingSuccess,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_SHOW_BATCH_JOB_STATUS_SUCCESS]: slsRtnFServ02ShowBatchJobStatusSuccess,

  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_RESET_TIMESTAMP]: slsRtnFServ02ResetTimestamp,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_FETCH_SLS_RTN_F_SERV02_LOADING]: slsRtnFServ02FetchSlsRtnFServ02Loading,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_FETCH_SLS_RTN_F_SERV02_SUCCESS]: slsRtnFServ02FetchSlsRtnFServ02Success,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_ADD_SELECTED_DOCUMENTS]: slsRtnFServ02AddSelectedDocuments,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_REMOVE_SELECTED_DOCUMENTS]: slsRtnFServ02RemoveSelectedDocuments,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_SET_WORKSPACE_VISIBLE]: slsRtnFServ02SetWorkspaceVisible,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_EXPORT_LOADING]: slsRtnFServ02ExportLoading,
  [SlsRtnFServ02Types.SLS_RTN_F_SERV02_EXPORT_SUCCESS]: slsRtnFServ02ExportSuccess
});
